// fix accessibility with screenreader
// https://github.com/JedWatson/react-select/issues/5190

import React from "react";
import { components } from "react-select";

export default (props) => {
  const { isSelected, innerProps } = props;
  // To make options selectable with VoiceOver/TalkBack, We should avoid using tabindex="-1".
  const { tabIndex: _, ...rest } = innerProps;

  return (
    <components.Option
      {...props}
      innerProps={{
        ...rest,
        role: 'option',
        'aria-selected': isSelected,
      }}
    />
  );
};
